import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import CardPage from "./pages/CardPage";
import axios from "axios";
import SignupPage from "./pages/SignupPage";
import Dashboard from "./pages/Dashboard";
import FlashcardSetEditor from "./pages/FlashcardSetEditor";
import FlashcardEditor from "./pages/FlashcardEditor";
import SetCreator from "./pages/SetCreator";
import ProfilePage from "./pages/ProfilePage";
import LoginPage from "./pages/LoginPage";
import UpdatePasswordPage from "./pages/UpdatePasswordPage";

import "./App.css";
import { API_URL } from "./config";

export default function App() {
  const userId = localStorage.getItem("userId");
  const [sets, setSets] = useState([]);
  useEffect(() => {
    axios
      .get(`${API_URL}/set/${userId}`)
      .then((res) => setSets(res.data.data))
      .catch((error) => console.error(error));
  }, []);

  const handleCreateSet = (newSet) => {
    setSets((prevSets) => [...prevSets, newSet]);
  };
  return (
    <>
      <Routes>
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/" element={<Dashboard sets={sets} setSets={setSets} />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/create"
          element={<SetCreator onCreateSet={handleCreateSet} />}
        />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/cards/:id" element={<CardPage />} />
        <Route path="/cards/:id/edit" element={<FlashcardSetEditor sets={sets} setSets={setSets}/>} />
        <Route path="/updatePassword" element={<UpdatePasswordPage />} />
        <Route path="/cards/:id/edit/:cardId" element={<FlashcardEditor />} />
      </Routes>
    </>
  );
}
